/**
 * @see https://umijs.org/zh-CN/plugins/plugin-access
 * */
export default function access(initialState: {
  currentUser?: API.CurrentUser | undefined;
  acceptTerm: boolean;
}) {
  const { currentUser, acceptTerm } = initialState || {};
  return {
    canAdmin: currentUser && currentUser.access === 'admin',
    acceptTerm,
  };
}
